const componentControlMixins = {
  props: {
    displayToggle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showComponent: true,
    }
  },
  mounted() {
    window.addEventListener('hideComponent', this.receiveMessage)
    window.addEventListener('showComponent', this.receiveMessage)
  },
  methods: {
    async receiveMessage(event) {
      if (event.detail.message === 'hideComponent') {
        if (this.displayToggle) this.showComponent = false
      }

      if (event.detail.message === 'showComponent') {
        if (this.displayToggle) this.showComponent = true
      }
    },
  },

}

export default componentControlMixins
